import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
/**
 * Wrapper for `react-select` that adds `required` prop.
 *
 * Effectively, this adds another input element that takes the `required` prop,
 * which passes its value down to the original `react-select` component.
 *
 * @see {@link https://github.com/JedWatson/react-select/issues/3140}
 */
class ReactSelectRequiredFixed extends Component {
    state = {
        value: this.props.value || '',
    };
    selectRef = null;
    // @ts-ignore
    setSelectRef = ref => {
        this.selectRef = ref;
    };
    // @ts-ignore
    onChange = (value, actionMeta) => {
        // @ts-ignore
        this.props.onChange(value, actionMeta);
        this.setState({ value });
    };
    getValue = () => {
        if (this.props.value != undefined)
            return this.props.value;
        return this.state.value || '';
    };
    render() {
        // @ts-ignore
        const { SelectComponent, required, ...props } = this.props;
        // @ts-ignore
        const { isDisabled } = this.props;
        const enableRequired = !isDisabled;
        return (_jsxs("div", { children: [_jsx(SelectComponent, { ...props, ref: this.setSelectRef, onChange: this.onChange }), enableRequired && (_jsx("input", { tabIndex: -1, autoComplete: "off", style: {
                        opacity: 0,
                        width: '100%',
                        height: 0,
                        position: 'absolute',
                    }, value: this.getValue(), onChange: () => { }, 
                    // @ts-ignore
                    onFocus: () => this.selectRef.focus(), required: required }))] }));
    }
}
export default ReactSelectRequiredFixed;
